import { render, staticRenderFns } from "./MarkerLabel.vue?vue&type=template&id=163db8f6&scoped=true&"
import script from "./MarkerLabel.vue?vue&type=script&lang=js&"
export * from "./MarkerLabel.vue?vue&type=script&lang=js&"
import style0 from "./MarkerLabel.vue?vue&type=style&index=0&id=163db8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163db8f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163db8f6')) {
      api.createRecord('163db8f6', component.options)
    } else {
      api.reload('163db8f6', component.options)
    }
    module.hot.accept("./MarkerLabel.vue?vue&type=template&id=163db8f6&scoped=true&", function () {
      api.rerender('163db8f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/PlaceFloorPlans/MarkerLabel.vue"
export default component.exports